
import ListUsers from "../../Components/Users/ListUsers"

export default function UsersPage() {
    return (
        <>
            <ListUsers />
        </>
    )
}